import { render } from "./RegionsTips.vue?vue&type=template&id=f31bd81c"
import script from "./RegionsTips.vue?vue&type=script&lang=js"
export * from "./RegionsTips.vue?vue&type=script&lang=js"

import "./RegionsTips.vue?vue&type=style&index=0&id=f31bd81c&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__